import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss';
import Button from '../buttons/Button';
import CheckboxRadio from '../form/checkbox/CheckboxRadio';
import { convertPrice } from './../.././services/convertPrice';
import formatPrice from '../../services/formatPrice';
import checkNaN from '../../services/checkNaN';

const LeasingRateBoxResult = ( props ) => {
    let rateFrequency     = useSelector(state => state.rateFrequency);
    let finalRate         = useSelector(state => state.finalRate);

    useEffect(() => {
        // console.log(finalRate)
    }, [finalRate])
    return (
        <div className="leasing-rate-box result-box">
            <div className="wrapper">
                { rateFrequency == 'kwartalnie' && 
                    <div className={"row active"}>
                        <div className="text-rate">
                            <p><strong>Quarterly</strong> 4 times a year</p>
                        </div>
                        {finalRate &&
                            <div className="price">
                                <p><strong>{ checkNaN(formatPrice(finalRate)) }</strong> net</p>
                            </div>
                        }
                    </div>
                }
                
                { rateFrequency == 'miesięcznie' &&
                    <div className={"row active"}>
                        <div className="text-rate">
                            <p><strong>Monthly</strong> 12 instalments</p>
                        </div>
                        {finalRate &&
                            <div className="price">
                                <p><strong>{ checkNaN(formatPrice(finalRate)) }</strong> net</p>
                            </div>
                        }
                    </div>
                }

                <div className="texta" dangerouslySetInnerHTML={ { __html: props.text } } />
            </div>
        </div>
    )
}

export default LeasingRateBoxResult;